// extracted by mini-css-extract-plugin
module.exports = {"dashed":"CouponDetailHeaderCenter_dashed__p9xIk"};